/*
 * @Date: 2023-11-02 15:38:23
 * @LastEditors: lihwang
 * @LastEditTime: 2023-11-09 18:22:07
 * @FilePath: /ckb-mall-web/src/container/cart/component/normalModal/index.tsx
 * @Description:
 * @Author: lihwang
 */
import React, { useState } from 'react';
import { Modal, Button } from 'antd';
interface ModalContent {
    text: string;
    onOk?: () => void;
    onCancel?: () => void;
}
export default function useModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState<ModalContent | null>(null);
    const openModal = (content: ModalContent) => {
        setModalContent(content);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const modalComponent = () => {
        return (
            <Modal
                width={400}
                open={isModalOpen}
                onOk={() => {
                    modalContent?.onOk?.();
                    closeModal();
                }}
                cancelText={window._$m.t('取消')}
                okText={window._$m.t('确定')}
                onCancel={() => {
                    modalContent?.onCancel?.();
                    closeModal();
                }}
            >
                <div className="py-[20px]">{modalContent?.text}</div>
            </Modal>
        );
    };
    return [modalComponent, openModal, closeModal] as const;
}
